export const reviewModalModalDialogActionsStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 1,
		width: '100%'
	},

	actions: {
		display: 'flex',
		gap: 1,
		width: '100%'
	}
};
